var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isRelevant)?_c('i',{staticClass:"tm-audio-wave",class:_vm.classObj},[_c('canvas',{ref:"display",staticClass:"-display",style:({ width: ((_vm.$data.canvasWidth) + "px") })})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }